// extracted by mini-css-extract-plugin
module.exports = {"icon-frame":"framed-icon_icon-frame__2JnP4","icon":"framed-icon_icon__1f7Em"};